<template>
    <div class='col-sm-12'>
        <div class="mb-3" :class="ingresado ? 'bg-primary' : pregunta.obligatoria ? 'obligatoria' : ''">
            <span v-if="muestraP">{{ pregunta.pregunta }}</span>
            {{ pregunta.literal }}
        </div>
        <button :disabled="ingresado" @click="creaEvaluacionDetalle()" :class="ingresado ? 'btn btn-primary' : 'btn'" type='button'>
            <i class='fa fa-clock-o'></i> Check
        </button>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        props: ['pregunta', 'evaluacion_id', 'muestraP'],
        data() {
            return {
                ingresado: false,
            }
        },
        methods: {
            creaEvaluacionDetalle() {
                // console.log(moment().format('h:mm:ss'));
                axios.post('/api/evaluacion_detalle/' + this.evaluacion_id, 
                    {
                        'hora_ini_app' : moment().format('H:mm:ss'),
                        'preguntas_paso_servicio_id' : this.pregunta.id,
                        'pregunta_texto' : this.pregunta.pregunta,
                        'valor' : null,
                        'texto' : null,
                        'completo' : true
                    }
                )
                .then(response => {
                    this.ingresado = true;
                    this.$emit('update:actualiza', response.data.data);

                })
                .catch(error => {
                    this.form.errors = ['Something went wrong. Please try again.'];
                });
            }
        },
    }
</script>

<style lang="scss" scoped>
    .obligatoria{
        background-color: #ff0000;
        color: #FFFFFF;
    }

    .bg-primary {
		background-color: #1ab394;
		border-color: #1ab394;
		color: #FFFFFF;
	}
</style>